<template>
  <div class="received-inve-page" style="height: 100%">
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group @reset="$gjReset" @query="$gjNoticeQuery">
          <gj-warehouse-select
            v-model="filter.warehouseIds"
            multiple
            :self="false"
            placeholder="仓库"
            width="180px"
          ></gj-warehouse-select>

          <gj-select-input
            v-model="filter.keyword"
            :options="[
              { id: 'msku', text: 'MSKU' },
              { id: 'fnsku', text: 'FNSKU' },
              { id: 'productName', text: '产品名称' },
              { id: 'shipmentId', text: 'ShipmentId' },
            ]"
          ></gj-select-input>
          <gj-select-date-picker
            :width="['160px']"
            v-model="filter.date"
            :options="[
              { id: 'zeroZoneDate', text: '收货时间（零时区）' },
              { id: 'marketDate', text: '收货时间（市场时区）' },
            ]"
            type="daterange"
          ></gj-select-date-picker>

          <template #right>
            <gj-tool-group
              :download="$permission('receiptsInventory:export')"
              download-url="/supply/receiptsInventory/export"
              :download-params="globalParams"
              setting
              :table-name="tableName"
              :table-columns="columns"
              :sort-gjtable="$refs.gjTable"
              help
            >
            </gj-tool-group>
          </template>
        </app-filter-group>
      </template>
      <template #table>
        <gj-table
          ref="gjTable"
          adaptParent
          :data="tableData"
          :columns="columns"
          :pagination="pagination"
          :loading="loading"
          :size="'has-picture'"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
          :default-sort="{ prop: 'warehouseName', order: 'descending' }"
        >
          <template #skus="{ row }">
            <div>
              <gj-tooltip :content="row.productName" :text-line="1"
                >产品名称: {{ row.productName || "-" }}</gj-tooltip
              >
            </div>
            <div>
              <gj-tooltip :content="row.sku" :text-line="1"
                >sku: {{ row.sku || "-" }}</gj-tooltip
              >
            </div>
          </template>
          <template #MSKUs="{ row }">
            <div> <gj-tooltip :content="row.fnsku" :text-line="1">fnsku: {{ row.fnsku || "-" }}</gj-tooltip> </div>
            <div> <gj-tooltip :content="row.msku" :text-line="1">msku: {{ row.msku || "-" }}</gj-tooltip> </div>
            <div></div>
          </template>
        </gj-table>
      </template>
    </app-base-main>
  </div>
</template>

<script>
import { queryMixin } from "@/minxins";
import { receiptsInventoryPage } from "@/api/statistics";
import { convertToDate } from "@/utils/date.util.js";
export default {
  name: "received-inve",
  mixins: [queryMixin],
  data() {
    return {
      tableData: [],
      columns: [
        {
          id: "warehouseName",
          header: "仓库",
          field: "warehouseName",
          minWidth: "120px",
          default: true,
          disabled: true,
          sortable: true,
        },
        {
          id: "sku",
          header: "产品名称/SKU",
          field: "slot:skus",
          minWidth: "120px",
          default: true,
        },
        {
          id: "msku",
          header: "FNSKU/MSKU",
          field: "slot:MSKUs",
          minWidth: "120px",
          default: true,
        },
        {
          id: "quantityShipped",
          header: "申报数量",
          field: "quantityShipped",
          minWidth: "120px",
          default: true,
        },
        {
          id: "quantity",
          header: "数量",
          field: "quantity",
          minWidth: "120px",
          default: true,
          sortable: true,
        },
        {
          id: "fbaShipmentId",
          header: "ShipmentId",
          field: "fbaShipmentId",
          minWidth: "120px",
          default: true,
        },
        {
          id: "fulfillmentCenterId",
          header: "亚马逊仓代码",
          field: "fulfillmentCenterId",
          minWidth: "120px",
          default: true,
        },
        {
          id: "zeroZoneDate",
          header: "收货时间（零时区）",
          field: "zeroZoneDate",
          minWidth: "120px",
          default: true,
          sortable: true,
        },
        {
          id: "marketDate",
          header: "收货时间（市场时区）",
          field: "marketDate",
          minWidth: "120px",
          default: true,
          sortable: true,
        },
      ],
      loading: false,
      filter: {
        keyword: {
          key: "msku",
          value: "",
        },
        date: {
          key: "zeroZoneDate",
          value: null,
        },
        warehouseIds: [],
      },
      globalParams: {},
      tableName: "received-inve-table",
    };
  },
  created() {
    this.sort.prop = "marketDate";
  },
  methods: {
    $gjQueryInitParams() {
      this.sort.prop = "marketDate";
      return {
        filter: {
          keyword: {
            key: "msku",
            value: "",
          },
          date: {
            key: "zeroZoneDate",
            value: null,
          },
          warehouseIds: [],
        },
      };
    },
    $gjQuery() {
      const params = {
        model: {
          warehouseIds: this.filter.warehouseIds,
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      params.model[this.filter.keyword.key] = this.filter.keyword.value;
      if (this.filter.date.value && this.filter.date.key == "zeroZoneDate") {
        params.model.startZeroZoneDate = convertToDate(
          this.filter.date.value[0]
        );
        params.model.endZeroZoneDate = convertToDate(this.filter.date.value[1]);
      }
      if (this.filter.date.value && this.filter.date.key == "marketDate") {
        params.model.startMarketDate = convertToDate(this.filter.date.value[0]);
        params.model.endMarketDate = convertToDate(this.filter.date.value[1]);
      }
      this.globalParams = params;
      this.loading = true;
      receiptsInventoryPage(params)
        .then((res) => {
          // console.log(res)
          this.tableData = res.records;
          this.pagination = this.getPagination(res);
        })
        .complete((_) => {
          this.loading = false;
        });
    },
  },
};
</script>